import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  addToModifiedParams,
  setModifiedParamsValidity,
} from "../../catalog-editing-page-actions";
import {
  getEditObjData,
  getModifiedParams,
} from "../../catalog-editing-page-selectors";
import { PersonalEditForm } from "./personal-edit-form";
import {
  getUniqFarm,
  getUniqPosition,
  getUniqWorkPlace,
  getIsReadonly,
} from "./personal-edit-form-selectors";

const mapStateToProps = createStructuredSelector({
  editObjData: getEditObjData,
  uniqFarm: getUniqFarm,
  uniqWorkPlace: getUniqWorkPlace,
  uniqPosition: getUniqPosition,
  modifiedParams: getModifiedParams,
  isReadonly: getIsReadonly,
});

const mapDispatchToProps = {
  addToModifiedParams,
  setModifiedParamsValidity,
};

export const PersonalEditFormController = connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalEditForm);
